export enum StatusCode {
  active = 1,
  inactive = 2,
  deleted = 3,
  pending = 4,
}

export enum StatusCodeKey {
  inventario = 1,
  prestada = 2,
  bajaVenta = 3,
  bajaExtravio = 4,
}
